<style lang="scss" scoped>
.about{
    margin-top: 200px;
    width: 200px;
    margin-left: 200px;
}

</style>

<template>
    <div class="about">
        <p>multiple filterable </p>    
        <ESelect 
            v-model="value" 
            reserve-keyword
            filterable 
            multiple
            clearable
            @visible-change="handleVisibleChange"
            @blur="handleBlur"
            @focus="handleFocus"
            placeholder="请选择" style="width: 400px;">
            <el-option label="全部" value=""> </el-option>
                <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
        </ESelect>
        <div class="mt20">no-multiple filterable</div>
        <ESelect 
            v-model="value" 
            reserve-keyword
            filterable 
            clearable
            @visible-change="handleVisibleChange"
            @blur="handleBlur"
            @focus="handleFocus"
            placeholder="请选择" style="width: 400px;">
            <!-- <el-option label="全部" value=""> </el-option> -->
                <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
        </ESelect>

        <div class="mt20">no-multiple</div>
        <ESelect 
            v-model="value" 
            reserve-keyword 
            clearable
            @visible-change="handleVisibleChange"
            @blur="handleBlur"
            @focus="handleFocus"
            placeholder="请选择" style="width: 400px;">
            <el-option label="全部" value=""> </el-option>
                <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
        </ESelect>

        <div class="mt20">no-multiple 全部</div>
        <ESelect 
            v-model="value" 
            reserve-keyword 
            clearable
            @visible-change="handleVisibleChange"
            @blur="handleBlur"
            @focus="handleFocus"
            placeholder="请选择" style="width: 400px;">
            <el-option label="全部" value=""> </el-option>
                <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
        </ESelect>
    </div>
</template>

<script>
    import { ESelect } from '@/components/Ele/eSelect';

    export default {
        components: {
            ESelect
        },
        data() {
            return {
                options: [{
                value: '选项1',
                label: '黄金糕'
                }, {
                value: '选项2',
                label: '南京双皮奶'
                }, {
                value: '选项3',
                label: '蚵仔煎'
                }, {
                value: '选项4',
                label: '龙须面'
                }, {
                value: '选项5',
                label: '北京烤鸭'
                }],
                value: [],
                value2:'',
                value3:'',
                value4:'',
            }
        },
        created() {

        },
        methods: {
            handleVisibleChange(visible) {
                // console.log('visible',visible);
            },
            handleBlur(e) {
                // console.log('blur',e.target.value);
            },
            handleFocus(e) {
                // console.log('focus',e.target.value);
            },
        }
    }
</script>
